// Clinic Configuration for Dentist in EdgeWater"
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Dentist in Edgewater",
  clinicId: "dentistinedgewater",
  clinicUrl: "https://dentistinedgewatermd.com/",
  // Contact Information
  phoneNumber: "(443) 334-6689",
  phoneNumberRaw: "+14433346689", // For tel: and sms: links
  email: "DentalCare@DentistinEdgewater.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistinedgewater&agentId=0e3b1ba0-0bcb-4982-8d94-d3b8c74fb128",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistinedgewater/voice",

  // Location
  address: "15 Lee Airpark Dr #100, Edgewater, MD 21037,United States",
  addressShort: "15 Lee Airpark Dr #100, Edgewater, MD 21037",
  city: "Edgewater",
  hcity: "Edgewater",
  state: "Maryland",
  stateShortForm: "MD",
  PostalCode: "21037",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/vy64M7JjjJEo7YKq8",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13717546.469172928!2d-91.4332445!3d32.9243243!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b7f3bf36f10427%3A0xac67aa775a7be52b!2sDentist%20in%20Edgewater!5e0!3m2!1sen!2sin!4v1756790627126!5m2!1sen!2sin',

  iframeTitle: "Dentist in EdgeWater",

  //membership
  membership: "https://member.kleer.com/?slug=XH7F",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/DentistInEdgewater",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/dentist-in-edgewater?utm_source=practice&utm_medium=email&m=65982",


  // Analytics
  clarityProjectId: "prd2n502ae",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistinedgewater",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistinedgewater",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistinedgewater",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://dentistinedgewatermd.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/people/Dentist-in-Edgewater/61560764425273/",
    instagram: "https://www.instagram.com/dentistinEdgewater/",
    twitter: "https://x.com/Dent_Edgewater",
    linkedin: "https://www.linkedin.com/authwall?trk=bf&trkInfo=AQGsWhtYDu0QrwAAAZm9gsUAQrpCNqL9OAu9iTbRb2lvDD-PA4V1g69B8Mbmds5B8F5B54wZGYUjLM-CfhZ4_NkWxNytxoNs_xHDEoDpn-sEoxdaWWU9tXLIV6FWv1sNx0p0Wz4=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F108102279%2Fadmin%2F%3Flipi%3Durn%253Ali%253Apage%253Ad_flagship3_feed%253BZHzZHS4UQLaEyel%252BGoze8g%253D%253D",
    youtube: "https://www.youtube.com/@DentistEdgewater",
  },

  // Open Dental Configuration
  defaultProvNum: 199,
  defaultOpNum: 6123,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: "New patient emergency/other",
      label: "New patient emergency/other",
      duration: 30,
      opNum: 6124,
      AppointmentTypeNum: 10,
    },
    {
      value: "Existing patient emergency/other",
      label: "Existing patient emergency/other",
      duration: 30,
      opNum: 11, // DEFAULT_OP_NUM
      AppointmentTypeNum: 23,
    },
    {
      value: "Existing patient current treatment Plan",
      label: "Existing patient current treatment Plan",
      duration: 30,
      opNum: 11, // DEFAULT_OP_NUM
      AppointmentTypeNum: 9,
    },
  ],

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:${this.phoneNumberRaw}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;
